import { useState } from "react";

import { DelayPickingOrderContext } from "./DelayPickingOrderContext";

const DelayPickingOrderProvider = ({ children }) => {
  const [isDelayPicking, setIsDelayPicking] = useState(false);

  return (
    <DelayPickingOrderContext.Provider
      value={{
        isDelayPicking,
        setIsDelayPicking,
      }}
    >
      {children}
    </DelayPickingOrderContext.Provider>
  );
};

export default DelayPickingOrderProvider;
